import React, {Component} from "react";
import T from "../t/T";
import "./Tabs.scss";

class Tabs extends Component {
    constructor(props) {
        super(props);
    }

    // Lifecycle methods

    // Private methods

    // Public methods

    render() {
        const { tabs = [], handleChangeTab } = this.props;

        let fragments = tabs.map(tab => "1fr").join(" ");

        return <div className="tabs" style={{gridTemplateColumns: fragments}}>
            {
                tabs.map(tab => {
                    return <div key={tab.id} className={`tab ${tab.id === this.props.activeTab ? "active" : "" }`} onClick={() => handleChangeTab(tab.id)}>
                        {tab.icon && <i className={tab.icon} />} <T token={tab.title} />
                    </div>;
                })
            }
        </div>;
    }
}

export default Tabs;
